import { GeneralService } from './../../../services/general.service';
import { FormGroup } from '@angular/forms';

export class FormRs005Build {

    public areaSelect: string = localStorage.getItem('area-select') || null;
    public async buildForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<FormGroup> {
        form = await this.buildFormI(form, arrForm[0], generalService);
        form = await this.buildFormII(form, arrForm[1], generalService);
        form = await this.buildFormIII(form, arrForm[2], generalService);
        form = await this.buildFormIV(form, arrForm[3], generalService);
        form = await this.buildFormV(form, arrForm[4], generalService);
        form = await this.buildFormVI(form, arrForm[5], generalService);
        form = await this.buildFormVII(form, arrForm[6], generalService);
        form = await this.buildFormVIII(form, arrForm[7], generalService);
        form = await this.buildFormIX(form, arrForm[8], generalService);
        form = await this.buildFormX(form, arrForm[9], generalService);
        form = await this.buildFormXI(form, arrForm[10], generalService);
        form = await this.buildFormXII(form, arrForm[11], generalService);
        form = await this.buildFormXIII(form, arrForm[12], generalService);
        form = await this.buildFormXIV(form, arrForm[13], generalService);

        return form;
    }

    private async buildFormI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('site_recebimento').setValue(formCard.get('site_recebimento')?.value);
            form.get('safra').setValue(formCard.get('safra')?.value);
            form.get('safra_basica').setValue(formCard.get('safra_basica')?.value);
            form.get('cerar_basica').setValue(formCard.get('cerar_basica')?.value);
            form.get('numero_campo').setValue(formCard.get('numero_campo')?.value);
            form.get('gleba').setValue(formCard.get('gleba')?.value);
            form.get('geracao').setValue(formCard.get('geracao')?.value);
            form.get('numero_caixa').setValue(formCard.get('numero_caixa')?.value);
            form.get('controle_caixa').setValue(formCard.get('controle_caixa')?.value);
            form.get('lote_rw').setValue(formCard.get('lote_rw')?.value);
            form.get('hibrido_rnc').setValue(formCard.get('hibrido_rnc')?.value);
            form.get('tipo_colheita').setValue(formCard.get('tipo_colheita')?.value);
            form.get('contrato_juridico').setValue(formCard.get('contrato_juridico')?.value);
            form.get('site_origem').setValue(formCard.get('site_origem')?.value);
            form.get('peso_pos_secagem').setValue(formCard.get('peso_pos_secagem')?.value);
            form.get('peso_rw').setValue(formCard.get('peso_rw')?.value);
            form.get('houve_troca_caixa').setValue(formCard.get('houve_troca_caixa')?.value);
            form.get('novo_numero_caixa').setValue(formCard.get('novo_numero_caixa')?.value);
            form.get('nota_granacao').setValue(formCard.get('nota_granacao')?.value);
            form.get('nota_ardida').setValue(formCard.get('nota_ardida')?.value);
        }
        else {
            form.get('cerar').setValue(formCard.get('Cerar')?.value);
            form.get('site_recebimento').setValue(formCard.get('Site_recebimento')?.value);
            form.get('safra').setValue(formCard.get('Safra')?.value);
            form.get('data_despalha').setValue(generalService.createDate(formCard.get('Data_despalha')?.value));
            form.get('hibrido_rnc').setValue(formCard.get('Hibrido_rnc')?.value);
            form.get('gleba').setValue(formCard.get('Gleba')?.value);
            form.get('contrato_juridico').setValue(formCard.get('Contrato_juridico')?.value);
            form.get('numero_campo').setValue(formCard.get('Nr_campo')?.value);
            form.get('peso_liq_carga_cooperante_kg').setValue(formCard.get('Peso_liq_carga_cooperante_kg')?.value);
            form.get('peso_amostra_cooperante_g').setValue(formCard.get('Peso_amostra_cooperante_g')?.value);
            form.get('peso_palha_cooperante_g').setValue(formCard.get('Peso_palha_cooperante_g')?.value);
            form.get('peso_impureza_cooperante_g').setValue(formCard.get('Peso_impureza_cooperante_g')?.value);
            form.get('peso_sabugo_cooperante_g').setValue(formCard.get('Peso_sabugo_cooperante_g')?.value);
            form.get('peso_semente_cooperante_g').setValue(formCard.get('Peso_semente_cooperante_g')?.value);
            form.get('umidade_prc').setValue(formCard.get('Umidade')?.value);
        }

        return await form;
    }

    private async buildFormII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('peso_espigas_atipicas_kg').setValue(formCard.get('peso_espigas_atipicas_kg')?.value);
            form.get('peso_espigas_fora_do_padrao_kg').setValue(formCard.get('peso_espigas_fora_do_padrao_kg')?.value);
            form.get('espigas_atipicas_prc').setValue(formCard.get('espigas_atipicas_prc')?.value);
            form.get('presenca_outras_sementes').setValue(formCard.get('presenca_outras_sementes')?.value);
            form.get('motivo_parada_resselecao').setValue(formCard.get('motivo_parada_resselecao')?.value);
            form.get('tempo_parada_selecao_hora').setValue(generalService.convertMaskToTime(formCard.get('tempo_parada_selecao_hora')?.value));
            form.get('caixa_pos_mesa').setValue(formCard.get('caixa_pos_mesa')?.value);
            form.get('peso_descarte_mesa_selecao_kg').setValue(formCard.get('peso_descarte_mesa_selecao_kg')?.value);
            form.get('peso_pos_mesa').setValue(formCard.get('peso_pos_mesa')?.value);
            form.get('resselecao').setValue(formCard.get('resselecao')?.value);
            form.get('desgrana_mesa').setValue(formCard.get('desgrana_mesa')?.value);
            form.get('inicio_selecao_data_hora').setValue(generalService.createDateTimeData(formCard.get('inicio_selecao_data')?.value, formCard.get('inicio_selecao_hora')?.value));
            form.get('fim_selecao_data_hora').setValue(generalService.createDateTimeData(formCard.get('fim_selecao_data')?.value, formCard.get('fim_selecao_hora')?.value));
        }
        else {
            form.get('total_espigas_granacao').setValue(formCard.get('Total_espigas_granacao')?.value);
            form.get('granacao_cem_prc').setValue(formCard.get('Granacao_100')?.value);
            form.get('granacao_setenta_cinco_prc').setValue(formCard.get('Granacao_75')?.value);
            form.get('granacao_cinquenta_prc').setValue(formCard.get('Granacao_50')?.value);
            form.get('granacao_vinte_cinco_prc').setValue(formCard.get('Granacao_25')?.value);
            form.get('granacao_zero_prc').setValue(formCard.get('Granacao_0')?.value);
            form.get('granacao_media_prc').setValue(formCard.get('Granacao_media')?.value);
        }
        return await form;
    }

    private async buildFormIII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('ataque_lagartas').setValue(formCard.get('ataque_lagartas')?.value);
            form.get('diploidia').setValue(formCard.get('diploidia')?.value);
            form.get('fusarium').setValue(formCard.get('fusarium')?.value);
            form.get('ataque_besouros').setValue(formCard.get('ataque_besouros')?.value);
            form.get('viviparidade').setValue(formCard.get('viviparidade')?.value);
            form.get('giberela').setValue(formCard.get('giberela')?.value);
            form.get('mortas').setValue(formCard.get('mortas')?.value);
            form.get('popped_kernel').setValue(formCard.get('popped_kernel')?.value);
            form.get('ponto_dupla').setValue(formCard.get('ponto_dupla')?.value);
            form.get('comentarios').setValue(formCard.get('comentarios')?.value);
        }
        else {
            form.get('status_wwb').setValue(formCard.get('Status_wwb')?.value);
            form.get('peso_amostra_g').setValue(formCard.get('Peso_amostra_g')?.value);
            form.get('peso_palha_mais_impureza_g').setValue(formCard.get('Peso_palha_imp_g')?.value);
            form.get('peso_graos_debulhados_g').setValue(formCard.get('Peso_graos_debulhados_g')?.value);
            form.get('peso_graos_espigas_inteiras_g').setValue(formCard.get('Peso_graos_espigas_inteiras_g')?.value);
            form.get('palha_cerar_prc').setValue(formCard.get('Palha_cerar')?.value);
            form.get('sabugo_cerar_prc').setValue(formCard.get('Sabugo_cerar')?.value);
            form.get('semente_cerar_prc').setValue(formCard.get('Semente_cerar')?.value);
            form.get('palha_amostra_prc').setValue(formCard.get('Palha_amostra')?.value);
            form.get('total_graos_perdidos_amostra_prc').setValue(formCard.get('Total_graos_perdidos_amostra')?.value);
            form.get('esteira_perda_espigas_inteiras_prc').setValue(formCard.get('Perda_por_espigas_inteiras')?.value);
        }
        return await form;
    }

    private async buildFormIV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('lote_ds').setValue(formCard.get('lote_ds')?.value);
            form.get('numero_caixa_debulha').setValue(formCard.get('numero_caixa')?.value);
            form.get('inicio_debulha_data_hora').setValue(generalService.createDateTimeData(formCard.get('inicio_debulha_data')?.value, formCard.get('inicio_debulha_hora')?.value));
            form.get('umidade_debulha_prc').setValue(formCard.get('umidade_debulha_prc')?.value);
            form.get('numero_bag_iniciado').setValue(formCard.get('numero_bag_iniciado')?.value);
            form.get('numero_bag_finalizado').setValue(formCard.get('numero_bag_finalizado')?.value);
            form.get('peso_bruto_bag_finalizado').setValue(formCard.get('peso_bruto_bag_finalizado')?.value);
            form.get('peso_liquido_bag_finalizado').setValue(formCard.get('peso_liquido_bag_finalizado')?.value);
            form.get('motivo_parada_debulha').setValue(formCard.get('motivo_parada_debulha')?.value);
            form.get('tempo_parada_debulha_hora').setValue(generalService.convertMaskToTime(formCard.get('tempo_parada_debulha_hora')?.value));
            form.get('fim_debulha_data_hora').setValue(generalService.createDateTimeData(formCard.get('fim_debulha_data')?.value, formCard.get('fim_debulha_hora')?.value));
            form.get('lote_pa').setValue(formCard.get('lote_pa')?.value);
            form.get('peso_pa_bruto').setValue(formCard.get('peso_pa_bruto')?.value);
            form.get('peso_pa_liquido').setValue(formCard.get('peso_pa_liquido')?.value);
            form.get('descarte_pa').setValue(formCard.get('descarte_pa')?.value);
            form.get('numero_sacos').setValue(formCard.get('numero_sacos')?.value);
        }
        else {
            form.get('peso_palha_carga_kg').setValue(formCard.get('Peso_palha_carga_kg')?.value);
            form.get('peso_liq_carga_com_umidade_kg').setValue(formCard.get('Peso_liquido_carga_umidade_kg')?.value);
            form.get('perda_processo_kg').setValue(formCard.get('Perda_processo_kg')?.value);
            form.get('peso_espigas_inteiras_perdidas_kg').setValue(formCard.get('Peso_espigas_inteiras_perdidas_kg')?.value);
        }
        return await form;
    }

    private async buildFormV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('limpeza_manual').setValue(formCard.get('limpeza_manual')?.value);
            form.get('inicio_limpeza_manual_data_hora').setValue(generalService.createDateTimeData(formCard.get('inicio_limpeza_manual_data')?.value, formCard.get('inicio_limpeza_manual_hora')?.value));
            form.get('fim_limpeza_manual_data_hora').setValue(generalService.createDateTimeData(formCard.get('fim_limpeza_manual_data')?.value, formCard.get('fim_limpeza_manual_hora')?.value));
        }
        else {
            form.get('depalha_perda_espigas_inteiras_prc').setValue(formCard.get('Perda_espigas_inteiras')?.value);
            form.get('perda_graos_debulhados_despalha_prc').setValue(formCard.get('Perda_graos_debulhados_despalha')?.value);
            form.get('perda_total_despalha_prc').setValue(formCard.get('Perda_total_despalha')?.value);
        }
        return await form;
    }

    private async buildFormVI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('selecao_horas').setValue(formCard.get('selecao_horas')?.value);
            form.get('debulhas_horas').setValue(formCard.get('debulhas_horas')?.value);
            form.get('tempo_atraso_secagem').setValue(formCard.get('tempo_atraso_secagem')?.value);
            form.get('tempo_atraso_selecao').setValue(formCard.get('tempo_atraso_selecao')?.value);
            form.get('tempo_parada_selecao').setValue(formCard.get('tempo_parada_selecao')?.value);
            form.get('tempo_parada_debulha').setValue(formCard.get('tempo_parada_debulha')?.value);
        }
        else {
            form.get('total_espigas_avaliadas_retorno').setValue(formCard.get('Total_espigas_avaliadas_retorno')?.value);
            form.get('numero_espigas_despalhadas_retorno').setValue(formCard.get('Num_espigas_despalhadas_retorno')?.value);
            form.get('total_espigas_avaliadas_mesa').setValue(formCard.get('Total_espigas_avaliadas_mesa')?.value);
            form.get('numero_espigas_com_palha_mesa').setValue(formCard.get('Num_espigas_palha_mesa')?.value);
            form.get('espigas_despalhadas_retorno_prc').setValue(formCard.get('Espigas_despalhadas_retorno')?.value);
            form.get('espigas_com_palha_mesa_selecao_prc').setValue(formCard.get('Espigas_palha_mesa')?.value);
        }
        return await form;
    }

    private async buildFormVII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('created_by').setValue(formCard.get('created_by')?.value);
            form.get('responsavel_lancamento').setValue(formCard.get('responsavel_lancamento')?.value);
            form.get('observacao').setValue(formCard.get('observacao')?.value);
        }
        else {
            // form.get('umidade_prc').setValue(formCard.get('Umidade')?.value);
            form.get('peso_liq_carga_sem_palha_carga_kg').setValue(formCard.get('Peso_liquido_carga_sem_palha_kg')?.value);
            form.get('peso_espigas_atipicas_kg').setValue(formCard.get('Peso_espigas_atipicas_kg')?.value);
            form.get('peso_espigas_fora_do_padrao_kg').setValue(formCard.get('Peso_espigas_fora_padrao_kg')?.value);
            form.get('peso_descarte_mesa_selecao_kg').setValue(formCard.get('Peso_descarte_mesa_selecao_kg')?.value);
            form.get('descarte_mesa_selecao_prc').setValue(formCard.get('Descarte_mesa_selecao')?.value);
            form.get('espigas_atipicas_prc').setValue(formCard.get('Espigas_atipicas')?.value);
            form.get('presenca_outras_sementes').setValue(formCard.get('Presenca_outras_sementes')?.value);
        }
        return await form;
    }


    private async buildFormVIII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (!this.areaSelect.includes('Pré-Básica')) {
            form.get('configuracao_rolos').setValue(formCard.get('Configuracao_rolos')?.value);
            form.get('tipo_calha').setValue(formCard.get('Tipo_calha')?.value);
            form.get('recobrimento_rolos_prc').setValue(formCard.get('Recobrimento_rolos')?.value);
            form.get('num_espigas_totais_primeira_contagem').setValue(formCard.get('Numero_espigas_totais_contagem_1')?.value);
            form.get('num_espigas_com_palha_primeira_contagem').setValue(formCard.get('Numero_espigas_com_palha_contagem_1')?.value);
            form.get('num_espigas_totais_segunda_contagem').setValue(formCard.get('Numero_espigas_totais_contagem_2')?.value);
            form.get('num_espigas_com_palha_segunda_contagem').setValue(formCard.get('Numero_espigas_com_palha_contagem_2')?.value);
            form.get('despalha_prc').setValue(formCard.get('Despalha')?.value);
            form.get('espigas_com_palha_prc').setValue(formCard.get('Espigas_palha')?.value);
            form.get('peso_medio_espigas_com_palha_g').setValue(formCard.get('peso_medio_espigas_com_palha_g')?.value);
            form.get('apc_ligado').setValue(formCard.get('apc_ligado')?.value);
        }
        return await form;
    }

    private async buildFormIX(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (!this.areaSelect.includes('Pré-Básica')) {
            form.get('linha_descarga').setValue(formCard.get('Linha_descarga')?.value);
            form.get('observacao').setValue(formCard.get('Observacao')?.value);
            form.get('turno_amostragem').setValue(formCard.get('Turno_amostragem')?.value);
            form.get('created_by').setValue(formCard.get('criado_por')?.value);
            form.get('responsavel_amostragem').setValue(formCard.get('Responsavel_amostragem')?.value);
            form.get('responsavel_lancamento').setValue(formCard.get('Responsavel_lancamento')?.value);
        }
        return await form;
    }

    private async buildFormX(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (!this.areaSelect.includes('Pré-Básica')) {
            form.get('total_espigas_morte_prematura').setValue(formCard.get('total_espigas_morte_prematura')?.value);
            form.get('morte_prematura_prc').setValue(formCard.get('morte_prematura_prc')?.value);
        }
        return await form;
    }

    private async buildFormXI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (!this.areaSelect.includes('Pré-Básica')) {
            form.get('total_espigas_outros_defeitos').setValue(formCard.get('total_espigas_outros_defeitos')?.value);
            form.get('tipo_defeito').setValue(formCard.get('tipo_defeito')?.value);
            form.get('outros_defeitos_prc').setValue(formCard.get('outros_defeitos_prc')?.value);
        }
        return await form;
    }


    private async buildFormXII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('viviparidade_selecao').setValue(formCard.get('viviparidade_selecao')?.value);
            form.get('popped_kernel_selecao').setValue(formCard.get('popped_kernel_selecao')?.value);
            form.get('ataque_fungos').setValue(formCard.get('ataque_fungos')?.value);
            form.get('ataque_lagartas_select').setValue(formCard.get('ataque_lagartas_select')?.value);
            form.get('morte_prematura_select').setValue(formCard.get('morte_prematura_select')?.value);
        }

        return await form;
    }

    private async buildFormXIII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('faixa_vermelha').setValue(formCard.get('faixa_vermelha')?.value);
            form.get('faixa_marrom').setValue(formCard.get('faixa_marrom')?.value);
        }

        return await form;
    }

    private async buildFormXIV(form: FormGroup, formCard: FormGroup, generalService: GeneralService): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('faixa_laranja').setValue(formCard.get('faixa_laranja')?.value);
            form.get('faixa_cinza').setValue(formCard.get('faixa_cinza')?.value);
        }

        return await form;
    }

    public async updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<void> {
        await this.updateFormI(form, arrForm[0], generalService);
        await this.updateFormII(form, arrForm[1], generalService);
        await this.updateFormIII(form, arrForm[2], generalService);
        await this.updateFormIV(form, arrForm[3], generalService);
        await this.updateFormV(form, arrForm[4], generalService);
        await this.updateFormVI(form, arrForm[5], generalService);
        await this.updateFormVII(form, arrForm[6], generalService);
        await this.updateFormVIII(form, arrForm[7], generalService);
        await this.updateFormIX(form, arrForm[8], generalService);
        await this.updateFormX(form, arrForm[9], generalService);
        await this.updateFormXI(form, arrForm[10], generalService);
        await this.updateFormXII(form, arrForm[11], generalService);
        await this.updateFormXIII(form, arrForm[12], generalService);
        await this.updateFormXIV(form, arrForm[13], generalService);

    }

    private async updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('site_recebimento').setValue(data.formulario.site_recebimento);
            formCard.get('cerar_basica').setValue(data.formulario.cerar_basica);
            formCard.get('safra').setValue(data.formulario.safra);
            formCard.get('safra_basica').setValue(data.formulario.safra_basica);
            formCard.get('numero_campo').setValue(data.formulario.numero_campo);
            formCard.get('gleba').setValue(data.formulario.gleba);
            formCard.get('numero_caixa').setValue(data.formulario.numero_caixa);
            formCard.get('geracao').setValue(data.formulario.geracao);
            formCard.get('controle_caixa').setValue(data.formulario.controle_caixa);
            formCard.get('lote_rw').setValue(data.formulario.lote_rw);
            formCard.get('hibrido_rnc').setValue(data.formulario.hibrido_rnc);
            formCard.get('tipo_colheita').setValue(data.formulario.tipo_colheita);
            formCard.get('contrato_juridico').setValue(data.formulario.contrato_juridico);
            formCard.get('site_origem').setValue(data.formulario.site_origem);
            formCard.get('peso_rw').setValue(data.formulario.peso_rw);
            formCard.get('peso_pos_secagem').setValue(data.formulario.peso_pos_secagem);
            formCard.get('houve_troca_caixa').setValue(data.formulario?.houve_troca_caixa);
            formCard.get('novo_numero_caixa').setValue(data.formulario?.novo_numero_caixa);
            formCard.get('nota_granacao').setValue(data.formulario?.nota_granacao);
            formCard.get('nota_ardida').setValue(data.formulario?.nota_ardida);
        }
        else {
            formCard.get('Site_recebimento').setValue(data.formulario.site_recebimento);
            formCard.get('Safra').setValue(data.formulario.safra);
            formCard.get('Data_despalha').setValue(generalService.convertStringToDate(data.formulario.data_despalha));
            // tslint:disable-next-line: max-line-length
            formCard.get('Cerar').setValue(data.formulario.cerar);
            formCard.get('Hibrido_rnc').setValue(data.formulario.hibrido_rnc);
            formCard.get('Gleba').setValue(data.formulario.gleba);
            formCard.get('Contrato_juridico').setValue(data.formulario.contrato_juridico);
            formCard.get('Nr_campo').setValue(data.formulario.numero_campo);
            formCard.get('Peso_liq_carga_cooperante_kg').setValue(data.formulario.peso_liq_carga_cooperante_kg);
            formCard.get('Peso_amostra_cooperante_g').setValue(data.formulario.peso_amostra_cooperante_g);
            formCard.get('Peso_palha_cooperante_g').setValue(data.formulario.peso_palha_cooperante_g);
            formCard.get('Peso_impureza_cooperante_g').setValue(data.formulario.peso_impureza_cooperante_g);
            formCard.get('Peso_sabugo_cooperante_g').setValue(data.formulario.peso_sabugo_cooperante_g);
            formCard.get('Peso_semente_cooperante_g').setValue(data.formulario.peso_semente_cooperante_g);
            formCard.get('Umidade').setValue(data.formulario.umidade_prc);
        }

    }

    private async updateFormII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {

            formCard.get('inicio_selecao_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_selecao_data_hora, true));
            formCard.get('inicio_selecao_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_selecao_data_hora, false));
            formCard.get('peso_espigas_atipicas_kg').setValue(data.formulario.peso_espigas_atipicas_kg);
            formCard.get('peso_espigas_fora_do_padrao_kg').setValue(data.formulario.peso_espigas_fora_do_padrao_kg);
            formCard.get('espigas_atipicas_prc').setValue(data.formulario.espigas_atipicas_prc);
            formCard.get('presenca_outras_sementes').setValue(data.formulario.presenca_outras_sementes);
            formCard.get('motivo_parada_resselecao').setValue(data.formulario.motivo_parada_resselecao);
            formCard.get('tempo_parada_selecao_hora').setValue(generalService.convertTimeToMask(data.formulario.tempo_parada_selecao_hora));
            formCard.get('caixa_pos_mesa').setValue(data.formulario.caixa_pos_mesa);
            formCard.get('peso_descarte_mesa_selecao_kg').setValue(data.formulario.peso_descarte_mesa_selecao_kg);
            formCard.get('peso_pos_mesa').setValue(data.formulario.peso_pos_mesa);
            formCard.get('resselecao').setValue(data.formulario.resselecao);
            formCard.get('fim_selecao_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.fim_selecao_data_hora, true));
            formCard.get('fim_selecao_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.fim_selecao_data_hora, false));
            formCard.get('desgrana_mesa').setValue(data.formulario.desgrana_mesa);
        }
        else {
            formCard.get('Total_espigas_granacao').setValue(data.formulario.total_espigas_granacao);
            formCard.get('Granacao_100').setValue(data.formulario.granacao_cem_prc);
            formCard.get('Granacao_75').setValue(data.formulario.granacao_setenta_cinco_prc);
            formCard.get('Granacao_50').setValue(data.formulario.granacao_cinquenta_prc);
            formCard.get('Granacao_25').setValue(data.formulario.granacao_vinte_cinco_prc);
            formCard.get('Granacao_0').setValue(data.formulario.granacao_zero_prc);
            formCard.get('Granacao_media').setValue(data.formulario.granacao_media_prc);
        }

    }

    private async updateFormIII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('ataque_lagartas').setValue(data.formulario.ataque_lagartas);
            formCard.get('ataque_besouros').setValue(data.formulario.ataque_besouros);
            formCard.get('diploidia').setValue(data.formulario.diploidia);
            formCard.get('fusarium').setValue(data.formulario.fusarium);
            formCard.get('viviparidade').setValue(data.formulario.viviparidade);
            formCard.get('mortas').setValue(data.formulario.mortas);
            formCard.get('popped_kernel').setValue(data.formulario.popped_kernel);
            formCard.get('ponto_dupla').setValue(data.formulario.ponto_dupla);
            formCard.get('comentarios').setValue(data.formulario.comentarios);
            formCard.get('giberela').setValue(data.formulario.giberela);
        }
        else {
            formCard.get('Status_wwb').setValue(data.formulario.status_wwb);
            formCard.get('Peso_amostra_g').setValue(data.formulario.peso_amostra_g);
            formCard.get('Peso_palha_imp_g').setValue(data.formulario.peso_palha_mais_impureza_g);
            formCard.get('Peso_graos_debulhados_g').setValue(data.formulario.peso_graos_debulhados_g);
            formCard.get('Peso_graos_espigas_inteiras_g').setValue(data.formulario.peso_graos_espigas_inteiras_g);
            formCard.get('Palha_cerar').setValue(data.formulario.palha_cerar_prc);
            formCard.get('Sabugo_cerar').setValue(data.formulario.sabugo_cerar_prc);
            formCard.get('Semente_cerar').setValue(data.formulario.semente_cerar_prc);
            formCard.get('Palha_amostra').setValue(data.formulario.palha_amostra_prc);
            formCard.get('Total_graos_perdidos_amostra').setValue(data.formulario.total_graos_perdidos_amostra_prc);
            formCard.get('Perda_por_espigas_inteiras').setValue(data.formulario.esteira_perda_espigas_inteiras_prc);
        }

    }

    private async updateFormIV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('lote_ds').setValue(data.formulario.lote_ds);
            formCard.get('numero_caixa').setValue(data.formulario.numero_caixa);
            formCard.get('umidade_debulha_prc').setValue(data.formulario.umidade_debulha_prc);
            formCard.get('numero_bag_iniciado').setValue(data.formulario.numero_bag_iniciado);
            formCard.get('numero_bag_finalizado').setValue(data.formulario.numero_bag_finalizado);
            formCard.get('peso_bruto_bag_finalizado').setValue(data.formulario.peso_bruto_bag_finalizado);
            formCard.get('peso_liquido_bag_finalizado').setValue(data.formulario.peso_liquido_bag_finalizado);
            formCard.get('motivo_parada_debulha').setValue(data.formulario.motivo_parada_debulha);
            formCard.get('tempo_parada_debulha_hora').setValue(generalService.convertTimeToMask(data.formulario.tempo_parada_debulha_hora));


            formCard.get('inicio_debulha_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_debulha_data_hora, true));
            formCard.get('inicio_debulha_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_debulha_data_hora, false));
            formCard.get('fim_debulha_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.fim_debulha_data_hora, true));
            formCard.get('fim_debulha_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.fim_debulha_data_hora, false));
            formCard.get('lote_pa').setValue(data.formulario.lote_pa);
            formCard.get('peso_pa_bruto').setValue(data.formulario.peso_pa_bruto);
            formCard.get('peso_pa_liquido').setValue(data.formulario.peso_pa_liquido);
            formCard.get('descarte_pa').setValue(data.formulario.descarte_pa);
            formCard.get('numero_sacos').setValue(data.formulario.numero_sacos);
        }
        else {
            formCard.get('Peso_palha_carga_kg').setValue(data.formulario.peso_palha_carga_kg);
            formCard.get('Peso_liquido_carga_umidade_kg').setValue(data.formulario.peso_liq_carga_com_umidade_kg);
            formCard.get('Perda_processo_kg').setValue(data.formulario.perda_processo_kg);
            formCard.get('Peso_espigas_inteiras_perdidas_kg').setValue(data.formulario.peso_espigas_inteiras_perdidas_kg);
        }
    }


    private async updateFormV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('limpeza_manual').setValue(data.formulario.limpeza_manual);

            if (data.formulario.inicio_limpeza_manual_data_hora) {
                formCard.get('inicio_limpeza_manual_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_limpeza_manual_data_hora, true));
                formCard.get('inicio_limpeza_manual_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.inicio_limpeza_manual_data_hora, false));
            }
            if (data.formulario.fim_limpeza_manual_data_hora) {
                formCard.get('fim_limpeza_manual_data').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.fim_limpeza_manual_data_hora, true));
                formCard.get('fim_limpeza_manual_hora').setValue(generalService.convertStringToDateOrTimeOnly(data.formulario.fim_limpeza_manual_data_hora, false));

            }
        }
        else {
            formCard.get('Perda_espigas_inteiras').setValue(data.formulario.depalha_perda_espigas_inteiras_prc);
            formCard.get('Perda_graos_debulhados_despalha').setValue(data.formulario.perda_graos_debulhados_despalha_prc);
            formCard.get('Perda_total_despalha').setValue(data.formulario.perda_total_despalha_prc);
        }
    }

    private async updateFormVI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('selecao_horas').setValue(data.formulario.selecao_horas);
            formCard.get('debulhas_horas').setValue(data.formulario.debulhas_horas);
            formCard.get('tempo_atraso_secagem').setValue(data.formulario.tempo_atraso_secagem);
            formCard.get('tempo_atraso_selecao').setValue(data.formulario.tempo_atraso_selecao);
            formCard.get('tempo_parada_selecao').setValue(data.formulario.tempo_parada_selecao);
            formCard.get('tempo_parada_debulha').setValue(data.formulario.tempo_parada_debulha);
        }
        else {
            formCard.get('Total_espigas_avaliadas_retorno').setValue(data.formulario.total_espigas_avaliadas_retorno);
            formCard.get('Num_espigas_despalhadas_retorno').setValue(data.formulario.numero_espigas_despalhadas_retorno);
            formCard.get('Total_espigas_avaliadas_mesa').setValue(data.formulario.total_espigas_avaliadas_mesa);
            formCard.get('Num_espigas_palha_mesa').setValue(data.formulario.numero_espigas_com_palha_mesa);
            formCard.get('Espigas_despalhadas_retorno').setValue(data.formulario.espigas_despalhadas_retorno_prc);
            formCard.get('Espigas_palha_mesa').setValue(data.formulario.espigas_com_palha_mesa_selecao_prc);
        }
    }

    private async updateFormVII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('created_by').setValue(data.formulario.created_by);
            formCard.get('responsavel_lancamento').setValue(data.formulario.responsavel_lancamento);
            formCard.get('observacao').setValue(data.formulario.observacao);
        }
        else {
            // formCard.get('Umidade').setValue(data.formulario.umidade_prc);
            formCard.get('Peso_liquido_carga_sem_palha_kg').setValue(data.formulario.peso_liq_carga_sem_palha_carga_kg);
            formCard.get('Peso_espigas_atipicas_kg').setValue(data.formulario.peso_espigas_atipicas_kg);
            formCard.get('Peso_espigas_fora_padrao_kg').setValue(data.formulario.peso_espigas_fora_do_padrao_kg);
            formCard.get('Peso_descarte_mesa_selecao_kg').setValue(data.formulario.peso_descarte_mesa_selecao_kg);
            formCard.get('Descarte_mesa_selecao').setValue(data.formulario.descarte_mesa_selecao_prc);
            formCard.get('Espigas_atipicas').setValue(data.formulario.espigas_atipicas_prc);
            formCard.get('Presenca_outras_sementes').setValue(data.formulario.presenca_outras_sementes);
        }

    }

    private async updateFormVIII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (!this.areaSelect.includes('Pré-Básica')) {
            formCard.get('Configuracao_rolos').setValue(data.formulario.configuracao_rolos);
            formCard.get('Tipo_calha').setValue(data.formulario.tipo_calha);
            formCard.get('Recobrimento_rolos').setValue(data.formulario.recobrimento_rolos_prc);
            formCard.get('Numero_espigas_totais_contagem_1').setValue(data.formulario.num_espigas_totais_primeira_contagem);
            formCard.get('Numero_espigas_com_palha_contagem_1').setValue(data.formulario.num_espigas_com_palha_primeira_contagem);
            formCard.get('Numero_espigas_totais_contagem_2').setValue(data.formulario.num_espigas_totais_segunda_contagem);
            formCard.get('Numero_espigas_com_palha_contagem_2').setValue(data.formulario.num_espigas_com_palha_segunda_contagem);
            formCard.get('Despalha').setValue(data.formulario.despalha_prc);
            formCard.get('Espigas_palha').setValue(data.formulario.espigas_com_palha_prc);
            formCard.get('apc_ligado').setValue(data.formulario.apc_ligado);
        }
    }

    private async updateFormIX(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (!this.areaSelect.includes('Pré-Básica')) {
            formCard.get('Linha_descarga').setValue(data.formulario.linha_descarga);
            formCard.get('Observacao').setValue(data.formulario.observacao);
            formCard.get('Turno_amostragem').setValue(data.formulario.turno_amostragem);
            formCard.get('criado_por').setValue(data.formulario.created_by);
            formCard.get('Responsavel_amostragem').setValue(data.formulario.responsavel_amostragem);
            formCard.get('Responsavel_lancamento').setValue(data.formulario.responsavel_lancamento);
        }
    }

    private async updateFormX(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (!this.areaSelect.includes('Pré-Básica')) {
            formCard.get('total_espigas_morte_prematura').setValue(data.formulario.total_espigas_morte_prematura);
            formCard.get('morte_prematura_prc').setValue(data.formulario.morte_prematura_prc);
        }
    }

    private async updateFormXI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (!this.areaSelect.includes('Pré-Básica')) {
            formCard.get('total_espigas_outros_defeitos').setValue(data.formulario.total_espigas_outros_defeitos);
            formCard.get('tipo_defeito').setValue(data.formulario.tipo_defeito);
            formCard.get('outros_defeitos_prc').setValue(data.formulario.outros_defeitos_prc);
        }
    }

    private async updateFormXII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('viviparidade_selecao').setValue(data.formulario.viviparidade_selecao);
            formCard.get('popped_kernel_selecao').setValue(data.formulario.popped_kernel_selecao);
            formCard.get('ataque_fungos').setValue(data.formulario.ataque_fungos);
            formCard.get('ataque_lagartas_select').setValue(data.formulario.ataque_lagartas_select);
            formCard.get('morte_prematura_select').setValue(data.formulario.morte_prematura_select);
        }
    }


    private async updateFormXIII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('faixa_vermelha').setValue(data.formulario.faixa_vermelha);
            formCard.get('faixa_marrom').setValue(data.formulario.faixa_marrom);
        }
    }

    private async updateFormXIV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('faixa_laranja').setValue(data.formulario.faixa_laranja);
            formCard.get('faixa_cinza').setValue(data.formulario.faixa_cinza);
        }
    }
}
